import Button, { type ButtonProps } from '@/components/Button/Button'
import { Search as SearchIcon } from 'lucide-react'
import { useSearchOverlay } from '@/app/[category]/[subCategory]/[norm]/SearchOverlay'

export default function SearchButton ({ size = 'small' }: { size?: ButtonProps['size'] }) {
  const dialog = useSearchOverlay((state) => state.dialog)
  return (
    <Button
      onClick={() => { dialog?.show() }}
      variant='flat'
      size={size}
      icon={SearchIcon}
      style={{ gap: '0.8rem' }}
    >
      Durchsuchen
    </Button>
  )
}
